import React from 'react';
import { Icon, List } from 'semantic-ui-react';
import { Fecha } from 'src/componentes';

type Cambio = Readonly<{
    origen: string;
    destino: string;
}>;
export type Props = Readonly<{
    registros: ReadonlyArray<{ readonly fecha: string; cambios: readonly Cambio[] }>;
}>;

const RegistroDeCambios = (props: Props) => {
    const { registros } = props;

    return (
        <>
            <div style={{ fontWeight: 700 }}>Cambios</div>

            <List style={{ overflow: 'auto', maxHeight: '170px' }}>
                {registros.map(registro => (
                    <List.Item key={registro.fecha}>
                        <List.Header>
                            <Fecha fecha={registro.fecha} />
                            <b>:</b>
                        </List.Header>
                        <List.List>
                            {registro.cambios.map(({ origen, destino }, i) => (
                                <List.Item key={i} style={{ display: 'flex', marginLeft: '10px' }}>
                                    <div style={{ width: '5em' }}>{origen}</div>
                                    <Icon name='long arrow alternate right' />
                                    <div style={{ marginLeft: '10px' }}>{destino}</div>
                                </List.Item>
                            ))}
                        </List.List>
                    </List.Item>
                ))}
            </List>
        </>
    );
};

export default RegistroDeCambios;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/CambiosDeCurso/componentes/RegistroDeCambios.tsx